import { ReturnedAction } from '../reduxTypes';

export const setUserModules = (value: Array<string> | null): ReturnedAction => ({
  type: 'SET_USER_MODULES',
  value
});

export const setUserID = (value: Array<string> | null): ReturnedAction => ({
  type: 'SET_USER_ID',
  value
});

export const setUserLogin = (value: boolean): ReturnedAction => ({
  type: 'SET_USER_LOGIN',
  value
});
